var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{staticClass:"shadow-sm px-5",attrs:{"toggleable":"md","type":"light","variant":"light"}},[_vm._t("leftItems"),_vm._t("rightItems")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }